import SurveyModal from './SurveyModal'

export default SurveyModal